var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCheckPlan = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.204 3.70411L24.6946 0.184639C24.5767 0.0664326 24.4166 0 24.2496 0C24.0827 0 23.9226 0.0664326 23.8047 0.184639L8.98268 15.0167C8.86478 15.1349 8.70468 15.2013 8.53772 15.2013C8.37076 15.2013 8.21067 15.1349 8.09276 15.0167L4.58335 11.4972C4.46544 11.379 4.30534 11.3126 4.13838 11.3126C3.97143 11.3126 3.81133 11.379 3.69342 11.4972L0.184009 15.0167C-0.0613365 15.2621 -0.0613365 15.6599 0.184009 15.9054L8.09276 23.8154C8.21067 23.9336 8.37076 24 8.53772 24C8.70468 24 8.86478 23.9336 8.98268 23.8154L28.204 4.58398C28.4436 4.3396 28.4436 3.94849 28.204 3.70411Z",
    fill: "#539ADA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckPlan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-plan.33e75ae1.svg";
export { ForwardRef as ReactComponent };